/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2018, Zumper
 * @description  Get a good precision for comparing map values for important changes.
 */

// https://en.wikipedia.org/wiki/Decimal_degrees#Precision
// https://developers.google.com/maps/documentation/javascript/tutorial#zoom-levels
const getPrecisionFromZoom = (zoom) => {
  if (!zoom) {
    return 2
  }

  // State: (10km)
  if (zoom <= 10) {
    return 1
  }

  // City: (1km)
  if (zoom <= 13) {
    return 2
  }

  // Hood: (100m)
  if (zoom <= 16) {
    return 3
  }

  // Street: (10m)
  if (zoom <= 19) {
    return 4
  }

  // 19 or more (1m)
  return 5
}

export default getPrecisionFromZoom
